/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BonusRedeem from "../BonusRedeem/BonusRedeem";
import {
  ClientPlatformCode,
  // ApiConfigData,
  DealCategoryData,
  // DealCategoryData_2,
  DealCouponFreqData,
  DefaultCardName,
  getDealCategoryNames,
  // FormatDate,
  // DealCouponFreqData_2,
  // GetMemberData,
  GetSegment,
  SectionContentMasterData,
  trackEvent,
  // SectionContentMasterData_2,
  UnlocksectionactivityData,
  UserIdAndStatusData,
  UtilityReducer,
} from "../../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import {
  onPostDealCouponCode,
  onPostDealCouponCodeReset,
} from "../../Store/Slices/dealCouponCodeSlice";

// import ClaimedModal from "./ClaimedModal";
// import RedeemFailedModal from "./RedeemFailedModal";
// import axiosIntegration from "../../Common/Axios/axiosIntegration";
// import API from "../../Common/Endpoint/serviceConstrants";

import RedeemFailedModal from "./RedeemFailedModal";
// import { decryptAES } from "../../Common/Axios/encrypt";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { onLandingHomePostLogin } from "../../Store/Slices/homePageLandingSlice";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";
import ConfirmCouponModal from "./ConfirmCouponModal";


const WelcomeVoucher = () => {
  const translation = getTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const segmentData = GetSegment();
  const { dealCouponFreqData } = DealCouponFreqData();
  const [error, setError] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const segments = segmentData?.data?.[0]?.mappedSegment;
  const homePageSlice = useSelector((state) => state.homePageSliceReducer);
  const { clientCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();

  // const apiconfig = ApiConfigData();
  // const clientCode = apiconfig?.find(
  //   (data) => data?.paramsKey === "clientCode"
  // )?.paramsValue;
  // const partnerCode = apiconfig?.find(
  //   (data) => data?.paramsKey === "partnerCode"
  // )?.paramsValue;
  const location = useLocation();
  const deal = location?.state?.deal;
  const dealCoupon = location?.state?.coupons;
  const validDates = dealCouponFreqData?.find(
    (findData) => findData?.dealCoupounId === dealCoupon?.id
  );
  const { sctionContentdata } = SectionContentMasterData();
  const orderHistory = useSelector((state) => state?.offerBenefitsReducer);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { dealCategoryData } = DealCategoryData();

  const card = UtilityReducer();
  const currentSegmentMapped = segments?.find(
    (filterData) => filterData?.segmentId === card?.segmentId
  );
  const unlock = useSelector((state) => state?.unlockSectionReducer);
  const getUnlock = UnlocksectionactivityData()

  const claimedUnits = getUnlock?.unlockData?.filter(
    (filterData) =>
      filterData?.sectionId === card?.sectionId && !filterData?.status
  );
  const unlockSectionContents = sctionContentdata?.filter(
    (filterData) => filterData?.sectionMasterId === card?.sectionId
  );
  const reDirectHome = card.claimLimit === claimedUnits?.length || claimedUnits?.length === unlockSectionContents?.length

  const dispatch = useDispatch();
  const dealData = useSelector((state) => state?.dealCouponCodeReducer);
  const identifier = useSelector(
    (state) => state?.validateLoginTokenSliceReducer?.data
  );

  const currentSegment = segments?.find(
    (filterData) => filterData?.segmentId === card?.segmentId
  )?.segmentId;
  const currentSegmentCard = segments?.find(
    (filterData) => filterData?.segmentId === card?.segmentId
  )?.subIdentifier;
  const currentCardData = card?.creditCards?.find(
    (filterData) => filterData?.identifier === currentSegmentCard
  );
  const selectedCardType = currentCardData?.identifiertype === "1002" ? "CreditCard" : currentCardData?.identifiertype === "1001" ? "DebitCard" : null;

  const openModal = (e, hotelMembershipValues) => {
    if (e)
      e.preventDefault();

    // Prevent multiple clicks
    if (isButtonDisabled) return;

    setIsButtonDisabled(true);

    const payload = {
      dealId: deal?.id,
      dealCoupounFrequencyId: validDates?.id,
      cardImage: currentCardData?.backgroundcolor,
      cardName: currentCardData?.cardname,
      cardNumber: currentCardData?.CardNoLast4Digit,
      sectionId: card?.sectionId,
      offerId: deal?.id,
      customeridentifier: identifier?.memberIdentifier,
      name: identifier?.memberProfile?.firstName,
      phoneNumber: identifier?.memberProfile?.mobileNumber,
      email: identifier?.memberProfile?.emailId,
      contentSourceType: "Deals",
      dealCoupounId: dealCoupon?.id,
      enabled: true,
      lastName: identifier?.memberProfile?.lastName,
      cardFirstFourDigits: currentCardData?.CardNoFirst6Digit,
      cardSrNo: currentCardData?.identifier,
      createdBy: 10,
      currentSegment: currentSegment,
      offerDetail: {
        offer_activation_date: currentSegmentMapped?.validFrom
          ? new Date(
            new Date(currentSegmentMapped.validFrom)
              .toISOString()
              .split("T")[0] + "T00:00:00.000Z"
          ).toISOString()
          : null,

        offer_expiry_date: currentSegmentMapped?.validTill
          ? new Date(
            new Date(currentSegmentMapped.validTill)
              .toISOString()
              .split("T")[0] + "T00:00:00.000Z"
          ).toISOString()
          : null,
        segment_id: currentSegmentMapped?.segmentId || null,
        segment_name: currentSegmentMapped?.segmentName || null,
        CardType: selectedCardType
      }
    };
    if (hotelMembershipValues && dealCoupon?.membershipType === translation.membership_hotel) {
      payload.membershipType = dealCoupon?.membershipType;
      payload.salutation = hotelMembershipValues?.salutation;
      payload.name = hotelMembershipValues?.name;
      payload.lastName = hotelMembershipValues?.lastName;
      payload.phoneNumber = hotelMembershipValues?.phoneNumber;
      payload.email = hotelMembershipValues?.email;
      payload.city = hotelMembershipValues?.city;
      payload.country = hotelMembershipValues?.country;
    }

    dispatch(onPostDealCouponCode(payload));
  };
  const closeModal = () => setIsModalOpen(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (dealData?.post_status_code === "200" && dealData.postDealCouponCodeData) {


    } else if (dealData.post_status_code === 400) {
      dispatch(onPostDealCouponCodeReset());
      setError(true);
      setIsButtonDisabled(false); // Re-enable button on error
    }

  }, [dealData]);


  useEffect(() => {
    if (dealData?.post_status_code === "200") {
      let cardCodeValue = [
        ...new Set(
          identifier?.otherListAttribute?.[0]?.valueDetails
            ?.filter(card => card.status === "1" || card.status === "2")
            ?.map(card => card.CardTypeName?.toLowerCase())
            .filter(Boolean)
        )
      ] || [];
      dispatch(onLandingHomePostLogin({ memberIdentifier: identifier?.memberIdentifier, cardCode: encodeURIComponent(cardCodeValue.join(", ")) }))
      setIsLoading(true);
      dispatch(onPostDealCouponCodeReset());
    } else if (dealData?.post_status_code) {
      dispatch(onPostDealCouponCodeReset());
      setIsButtonDisabled(false); // Re-enable button on error
    }
  }, [dealData]);

  useEffect(() => {
    if (isLoading && homePageSlice?.status_code) {
      setIsLoading(false);
      setIsModalOpen(true);
    }
  }, [homePageSlice]);

  useEffect(() => {
    if (claimedUnits?.length >= card.claimLimit) {
      navigate("/");
      sessionStorage.removeItem("postLoginSuccesCount");
    }
  }, []);

  const handleRedeem = (e) => {
    if (dealCoupon?.membershipType === translation?.membership_hotel) {
      setIsConfirmModalOpen(true);
    } else {
      // Existing Flow
      openModal(e);
    }
    trackEvent("coupon_redeem_click", {
      // coupon_name: coupon?.title,
      image_url: `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal?.brandOfferImg}`,
      title: dealCoupon?.title,
      brand_name: deal?.name,
      page_type: location?.pathname === "/" ? "home_page" : "Offers & Deals",
      page_url: dealCoupon?.cta,
      section_title: "Claim your welcome bonus",
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
  }

  return (
    <>
      <div className="voucher-container">
        <div className="voucher-top">
          {<CustomBackHeader
            title={""}
            isTransperent={true}
          //backArrowIconComponent={<div className="back-arrow-button"  ><i className="fa fa-angle-left"></i></div>}
          />}
          <div className="brand-logo">
            <img
              src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal?.brandOfferImg}`}
              alt="Brand Logo"
              className="object-cover"
            />
          </div>

          <div className="voucher-redeem">
            <div className="voucher-details">
              <h2>{deal?.name}</h2>
            </div>
            <span className="title">
              {/* {
                dealCategoryData?.find(
                  (findData) => findData?.id === deal?.category
                )?.name
              } */}
              {getDealCategoryNames(dealCategoryData, [dealCoupon?.category])}
            </span>

            <div className="how-to-redeem">
              <h3>{translation?.howToRedeem}</h3>
              <div
                className="descrip  [&_ul]:list-inside
             [&_ul]:space-y-2
             [&_li]:pl-4
             [&_li]:-indent-4"
                dangerouslySetInnerHTML={{
                  __html: dealCoupon?.description,
                }}
              ></div>
            </div>

            <Link to={`/terms-condition?couponId=${dealCoupon?.id}`}>
              <button className="terms-button ">
                {translation?.termsAndConditions}
                <span className="forward-arrow">
                  <i className="fa fa-angle-right"></i>
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div >
      <div className="voucher-bottom">
        {/* <div className="redeem-button" onClick={() => mailerSend()}>SendMailer</div> */}
        <button
          className="redeem-button"
          onClick={(e) => handleRedeem(e)}
          disabled={
            isButtonDisabled ||
            dealCoupon?.isPostLoading ||
            unlock?.isPostLoading ||
            isLoading ||
            orderHistory?.isPostLoading
          }
        >
          {translation?.redeem}
          {(dealData?.isPostLoading ||
            unlock?.isPostLoading ||
            isLoading ||
            orderHistory?.isPostLoading) && (
              <span className="loader-icon pl-4 pt-4">
                <i className="fas fa-spinner fa-spin"></i>{" "}
              </span>
            )}
        </button>
      </div>

      {
        isModalOpen && (
          <BonusRedeem
            closeModal={closeModal}
            postDealCouponCodeData={dealData}
            reDirect={reDirectHome}
            dealCoupon={dealCoupon}
            dealName={deal?.name}
          />
        )
      }

      {
        error && (
          <RedeemFailedModal navigate={navigate} reDirect={reDirectHome} />
        )
      }
      {isConfirmModalOpen && <ConfirmCouponModal onCouponClose={setIsConfirmModalOpen} dealCoupon={dealCoupon} openModal={openModal} />}
    </>
  );
};

export default WelcomeVoucher;
